import React from 'react'
import { Chip } from './chips'

interface LockStatusChipProps {
  canBeLocked?: boolean
  isLocked?: boolean
  onClick: () => void
}

export default function LockStatusChip({ canBeLocked, isLocked, onClick }: LockStatusChipProps) {
  return (
    <Chip onClick={onClick} variant={isLocked ? 'green' : canBeLocked ? 'blue' : 'red'}>
      {isLocked ? 'Complete' : canBeLocked ? 'Can Be Locked' : 'Incomplete'}
    </Chip>
  )
}
